import { render, staticRenderFns } from "./productLabelTable.vue?vue&type=template&id=95e65ff6&"
import script from "./productLabelTable.vue?vue&type=script&lang=js&"
export * from "./productLabelTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports